import { resolveRuntimeEnvironment } from './runtimeEnvironment';

export const getUiBasePath = (): string => {
  // Stacks that don't set VITE_UI_BASE_PATH (most dev ECS stacks; app runs at '/') leave the
  // unresolved placeholder here, which is truthy and would otherwise reach React Router as a
  // bogus basename that matches no routes, rendering an empty page. Fall back to serving at root.
  const raw = resolveRuntimeEnvironment(import.meta.env.VITE_UI_BASE_PATH, '/');
  return raw === '/' ? '/' : raw.replace(/\/$/, '');
};

/**
 * Returns the UI base path as a prefix for building full paths.
 * Returns '' when serving at root, or '/v3' when serving at a sub-path.
 */
export const getUiBasePathPrefix = (): string => {
  const basePath = getUiBasePath();
  return basePath === '/' ? '' : basePath;
};

export const getApiBasePath = (): string => {
  const raw = resolveRuntimeEnvironment(import.meta.env.VITE_API_BASE_PATH, '/v3');
  return raw === '/' ? '' : raw.replace(/\/$/, '');
};
